var map = {
	"./AveriaSerif-Regular.ttf": "ba21",
	"./cityphography-geojson-colored-20211007203446": "274e",
	"./cityphography-geojson-colored-20211007203446.json": "274e",
	"./css/main.scss": "a0d8",
	"./css/mixins.css": "ee5d",
	"./css/mixins.scss": "94ea",
	"./css/normalize.scss": "2a6a",
	"./images/294.svg": "2050",
	"./images/833-loop.svg": "49dd",
	"./images/833.gif": "ecb9",
	"./images/833.svg": "58ac",
	"./images/banner-b.png": "2192",
	"./images/banner-e.png": "3ced",
	"./images/banner-k.png": "f8b2",
	"./images/banner-p.png": "a6b9",
	"./images/banner-t.png": "d83a",
	"./images/banner-t2.png": "6dd3",
	"./images/banner-transparent.png": "8497",
	"./images/banner-v.png": "72d9",
	"./images/banner.jpg": "301c",
	"./images/banner_sample.jpg": "b465",
	"./images/banner_sample2.jpg": "57f9",
	"./images/banner_sample3.jpg": "7f93",
	"./images/black-frame-left-shadowed.png": "a670",
	"./images/black-frame-left.png": "cc7b",
	"./images/black-frame-middle-shadowed-1.png": "25d9",
	"./images/black-frame-middle-shadowed-10.png": "c7b1",
	"./images/black-frame-middle-shadowed-100.png": "cb71",
	"./images/black-frame-middle-shadowed.png": "3b8e",
	"./images/black-frame-middle.png": "e2bf",
	"./images/black-frame-right-shadowed.png": "3b13",
	"./images/black-frame-right.png": "519b",
	"./images/black-frame.png": "b078",
	"./images/budapest.jpg": "c1ed",
	"./images/cart-green-bg.jpg": "7de6",
	"./images/cart-icon-bold.png": "512a",
	"./images/cart-icon-dark.png": "5021",
	"./images/cart-icon-empty.png": "890d",
	"./images/cart-icon-hover.png": "3f99",
	"./images/cart-icon-medium-dark.png": "a9bd",
	"./images/cart-icon-medium-hover.png": "1a28",
	"./images/cart-icon-medium.png": "d8e7",
	"./images/cart-icon.png": "9ad8",
	"./images/cart-pure-bg.jpg": "de30",
	"./images/cart-white-bg.jpg": "cfaa",
	"./images/cart-white2-bg.jpg": "54e1",
	"./images/classic-black-frame-left-shadowed.png": "9126",
	"./images/classic-black-frame-middle-shadowed-1.png": "7a73",
	"./images/classic-black-frame-middle-shadowed-10.png": "21fd",
	"./images/classic-black-frame-middle-shadowed-100.png": "0152",
	"./images/classic-black-frame-right-shadowed.png": "1e02",
	"./images/facebook-svgrepo-com.svg": "83f3",
	"./images/frame-customize-icon.svg": "60c7",
	"./images/frame-shuffle-icon.png": "a8dd",
	"./images/frame-shuffle-icon.svg": "e39d",
	"./images/frame-zoom-icon.png": "4921",
	"./images/frame-zoom-in-icon.png": "9a6f",
	"./images/frame-zoom-out-icon.png": "56f0",
	"./images/grey-mat.png": "23b8",
	"./images/heart-icon.png": "240f",
	"./images/iconfinder_duplicate_3017914.svg": "fb05",
	"./images/iconfinder_facebook-social-media_765252-dark.svg": "53fd",
	"./images/iconfinder_facebook-social-media_765252.svg": "fee0",
	"./images/iconmonstr-facebook-1.svg": "9a5d",
	"./images/iconmonstr-facebook-messenger-1.svg": "ab75",
	"./images/iconmonstr-instagram-11.svg": "22f0",
	"./images/iconmonstr-twitter-1-dark.svg": "86e4",
	"./images/iconmonstr-twitter-1.svg": "e868",
	"./images/instagram-logo-100-white.png": "c3c9",
	"./images/instagram-logo-100.png": "4625",
	"./images/instagram-logo.png": "0071",
	"./images/jpg-download-icon-dark.png": "bebe",
	"./images/jpg-download-icon.png": "02fa",
	"./images/kanapen.jpg": "3382",
	"./images/logo-bold-dark.png": "810a",
	"./images/logo-bold-old.png": "c632",
	"./images/logo-bold-white-stroke.png": "0533",
	"./images/logo-bold-white.png": "d14a",
	"./images/logo-bold.gif": "b67e",
	"./images/logo-bold.png": "c365",
	"./images/logo-peace-dark.png": "01e9",
	"./images/logo-peace-white-stroke.png": "647c",
	"./images/logo-peace.png": "5506",
	"./images/logo-regular.gif": "63dd",
	"./images/logo-regular.png": "3e8d",
	"./images/mapbox-compass-dark.svg": "1827",
	"./images/mask-image-left.png": "5ee8",
	"./images/mask-image-right.png": "5910",
	"./images/metal-black-frame-left-shadowed.png": "b0d5",
	"./images/metal-black-frame-middle-shadowed-1.png": "8857",
	"./images/metal-black-frame-middle-shadowed-10.png": "db8a",
	"./images/metal-black-frame-middle-shadowed-100.png": "7133",
	"./images/metal-black-frame-right-shadowed.png": "1cf3",
	"./images/modern-black-frame-left-shadowed.png": "ec7b",
	"./images/modern-black-frame-middle-shadowed-1.png": "ce62",
	"./images/modern-black-frame-middle-shadowed-10.png": "9323",
	"./images/modern-black-frame-middle-shadowed-100.png": "8fe7",
	"./images/modern-black-frame-right-shadowed.png": "8d53",
	"./images/modern-frame-brown.png": "3717",
	"./images/modern-frame.png": "a1b9",
	"./images/modernwide-black-frame-left-shadowed.png": "9057",
	"./images/modernwide-black-frame-middle-shadowed-1.png": "5767",
	"./images/modernwide-black-frame-middle-shadowed-10.png": "dd78",
	"./images/modernwide-black-frame-middle-shadowed-100.png": "9fe4",
	"./images/modernwide-black-frame-right-shadowed.png": "dd52",
	"./images/pinterest-social-logo-svgrepo-com-dark.svg": "d473",
	"./images/pinterest-social-logo-svgrepo-com.svg": "af6c",
	"./images/send-icon.png": "3201",
	"./images/triangleruler.png": "2381",
	"./images/variant-placeholder-dark.png": "0b34",
	"./images/variant-test.jpg": "7e82",
	"./logo-bold-beta-small.png": "941d",
	"./logo-bold-beta.jpg": "77c2",
	"./logo-bold-beta.png": "6dcf",
	"./logo-bold-dark-beta-small.png": "6b86",
	"./logo-bold-dark-beta.jpg": "4786",
	"./logo-bold-dark-beta.png": "faa0",
	"./logo-bold-dark.png": "8958",
	"./logo-bold-old.png": "ec34",
	"./logo-bold-white-stroke.png": "1ced",
	"./logo-bold.png": "7153",
	"./logo-peace-beta.jpg": "5f04",
	"./logo-peace-beta.png": "58b7",
	"./logo-peace-dark-beta.jpg": "6173",
	"./logo-peace-dark-beta.png": "4955",
	"./logo-peace-dark.png": "b40a",
	"./logo-peace-white-stroke.png": "90b9",
	"./logo-peace.png": "e50c",
	"./logo.png": "cf05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";